import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import * as QRious from 'qrious';
import { Apiservice } from 'src/app/services/apiservice';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
@Component({
  selector: 'app-admitcard',
  imports: [CommonModule],
  templateUrl: './admitcard.html',
  styleUrl: './admitcard.scss'
})
export class Admitcard {
  receivedData: any = history.state.userDetails || [];
  melaDetails: any;
  header: any = history.state.header
  date: string;
  selectedColor: string = '#ffffff';
  qrDataArray: any[];
  userName: any;
  @ViewChild('pdfContent', { static: false }) pdfContent!: ElementRef;
  constructor(private router: Router, private api: Apiservice, private acrouter: ActivatedRoute) {
    console.log(this.receivedData, 'Received data in PrintView');
    console.log(this.melaDetails, 'Index in PrintView');
    this.date = moment().utcOffset("+05:30").format("DD-MM-YYYY");
    // this.getProfileData();
    this.acrouter.queryParams.subscribe((res: any) => {
      console.log(res);
      this.getProfileData(res);
    })



  }

  getProfileData(res) {
    let obj = {
      "applicationId": res.reqId,
      "userId": res.userId
    }
    this.api.getUserAdmitCard(obj).subscribe((res: any) => {
      console.log(res);
      if (res.status == 200) {
        let user = res.data[0];
        console.log(user);
        this.userName = user.user_name

        this.receivedData = res.data;
        this.melaDetails = user;
        setTimeout(() => this.generateQrCodes(), 100);
      }
    }, err => {
    })
  }

  // getUserAppliedApplications() {
  //   this.api.getUserAppliedApplications().subscribe((res: any) => {
  //     if (res.status == 200) {
  //       console.log(res);
  //       // this.shgmembersReport = res.data;
  //     }
  //   }, err => {
  //   })
  // }

  ngAfterViewInit() {
    // setTimeout(() => this.generateQrCodes(), 100);
  }

  generateQrCodes() {
    console.log(this.receivedData, '9998');
    const qrDataArray: any[] = [];

    this.receivedData.forEach((officer: any) => {
      const canvasId = `qr-code${officer.id}`
      console.log(canvasId, '0000');
      const element = document.getElementById(canvasId);
      console.log(element, '8888');

      if (element) {
        const qrData = JSON.stringify({
          name: officer.user_name,
          id: officer.id,
          // image: officer.image,
          // rank: officer.ofcr_rank,
          mobile: officer.phone_number,
          // station: officer.station_name,
          district_name: officer.district_name,
          // component: officer.component_name,
          date: this.date
        });

        qrDataArray.push(qrData);


        new QRious({
          element: element,
          // value: qrData,
          //  value: `http://localhost:9658//MainMastersApi/assets2/?id=${officer.officer_id}&bandobast_id=${officer.bandobast_id}`,
          value: `https://jobmela.mepmaap.com/qrprofile?admitcard?reqId=${officer.melareqId}&userId=${officer.userreqId}`,
          size: 150,
          level: 'H'
        });
      }
    });

    console.log(qrDataArray, 'Final QR Data Array');
    this.qrDataArray = qrDataArray;
  }

  printContent() {
    window.print();
  }
  Back() {
    this.router.navigateByUrl('/profile');
  }

  breakLines(text: string): string[] {
    const maxLineLength = 35;
    const lines = [];
    for (let i = 0; i < text.length; i += maxLineLength) {
      lines.push(text.slice(i, i + maxLineLength));
    }
    return lines;
  }


  downloadPDF() {
    const element = this.pdfContent.nativeElement;

    // Set the width to match screen layout before capture
    const originalWidth = element.offsetWidth;
    const scale = 2; // capture high-quality image

    html2canvas(element, {
      scale: scale,
      useCORS: true,
      backgroundColor: '#ffffff',
      scrollX: 0,
      scrollY: 0,
      windowWidth: document.documentElement.offsetWidth
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');

      const pdf = new jsPDF('p', 'mm', 'a4'); // keep A4
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Convert canvas pixel size to mm (keeping aspect ratio)
      const imgWidth = pageWidth * 0.9; // 80% of page width (centered)
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      const x = (pageWidth - imgWidth) / 2;
      const y = (pageHeight - imgHeight) / 2;

      pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);
      pdf.save('JobMelaCard.pdf');
    });
  }
  async downloadinvoicepdf() {
    const DATA = document.getElementById('invoicepdfdownload');
    if (!DATA) return;

    // add this block right here ⤵️
    const CORS_PROXY = 'https://www.amaravathi.one:5288/api-proxy/';
    const img = DATA.querySelector('#profileImage') as HTMLImageElement;

    if (img && img.src.startsWith('http') && !img.src.startsWith(CORS_PROXY)) {
      img.crossOrigin = 'anonymous';
      img.src = CORS_PROXY + img.src;
    }

    // the rest of your function stays the same
    const cards = DATA.querySelectorAll('.singleCard');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    let cardIndex = 0;

    const captureCard = () => {
      if (cardIndex >= cards.length) {
        pdf.save(`${this.userName ? this.userName : 'JobMelaCard'}.pdf`);
        return;
      }

      const card = cards[cardIndex] as HTMLElement;

      html2canvas(card, {
        scale: 3,
        useCORS: true,
        backgroundColor: '#ffffff',
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = pageWidth * 0.9;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        const x = (pageWidth - imgWidth) / 2;
        const y = (pageHeight - imgHeight) / 2;

        if (cardIndex > 0) pdf.addPage();
        pdf.addImage(imgData, 'PNG', x, y, imgWidth, imgHeight);

        cardIndex++;
        captureCard();
      });
    };

    captureCard();
  }

  waitForImagesToLoad(container: HTMLElement): Promise<void> {
    const images = Array.from(container.getElementsByTagName('img'));
    console.log(images);

    return Promise.all(
      images.map(img => {
        if (img.complete) return Promise.resolve();
        return new Promise(resolve => {
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    ).then(() => undefined);
  }

}
